<section class="page">
  <header class="page-header">
    <div>
      <h1>Partner categories</h1>
      <p>Categories shown on the Earn tab (Fashion, Travel, Dining, …)</p>
    </div>
    <button class="btn btn-primary" type="button" (click)="openCreate()" [disabled]="saving()">
      Add category
    </button>
  </header>

  @if (error()) {
    <div class="alert alert-error">{{ error() }}</div>
  }
  @if (success()) {
    <div class="alert alert-success">{{ success() }}</div>
  }

  @if (showForm()) {
    <div class="panel create-panel">
      <h2>{{ editingId() ? 'Edit category' : 'Create category' }}</h2>
      <form [formGroup]="form" (ngSubmit)="save()" class="create-form">
        <label>
          <span>Name</span>
          <input type="text" formControlName="name" placeholder="Fashion" />
        </label>
        <label>
          <span>Slug</span>
          <input type="text" formControlName="slug" placeholder="auto from name if empty" />
        </label>
        <label>
          <span>Icon URL</span>
          <input type="text" formControlName="icon_url" placeholder="https://…" />
        </label>
        <label>
          <span>Sort order</span>
          <input type="number" formControlName="sort_order" />
        </label>
        <label class="checkbox">
          <input type="checkbox" formControlName="is_active" />
          <span>Active</span>
        </label>
        <div class="actions">
          <button class="btn btn-primary" type="submit" [disabled]="saving()">
            {{ saving() ? 'Saving…' : 'Save' }}
          </button>
          <button class="btn btn-secondary" type="button" (click)="cancelForm()" [disabled]="saving()">
            Cancel
          </button>
        </div>
      </form>
    </div>
  }

  <div class="panel">
    <div class="table-wrap">
      <table>
        <thead>
          <tr>
            <th>ID</th>
            <th>Name</th>
            <th>Slug</th>
            <th>Sort</th>
            <th>Status</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          @if (loading()) {
            <tr><td colspan="6" class="muted">Loading…</td></tr>
          } @else if (!rows().length) {
            <tr><td colspan="6" class="muted">No categories yet</td></tr>
          } @else {
            @for (row of rows(); track row.id) {
              <tr>
                <td>{{ row.id }}</td>
                <td>{{ row.name }}</td>
                <td class="mono">{{ row.slug }}</td>
                <td>{{ row.sort_order ?? 0 }}</td>
                <td>
                  <span class="badge" [attr.data-status]="row.is_active ? 'active' : 'pending'">
                    {{ row.is_active ? 'active' : 'inactive' }}
                  </span>
                </td>
                <td class="row-actions">
                  <button class="btn btn-secondary btn-sm" type="button" (click)="openEdit(row)">Edit</button>
                  <button class="btn btn-ghost btn-sm" type="button" (click)="remove(row)" [disabled]="saving()">
                    Delete
                  </button>
                </td>
              </tr>
            }
          }
        </tbody>
      </table>
    </div>
    @if (total() > limit) {
      <div class="pager">
        <span class="muted">Page {{ page() }} / {{ totalPages() }} ({{ total() }} total)</span>
        <div class="pager-actions">
          <button class="btn btn-secondary btn-sm" type="button" [disabled]="page() <= 1 || loading()" (click)="load(page() - 1)">
            Prev
          </button>
          <button class="btn btn-secondary btn-sm" type="button" [disabled]="page() >= totalPages() || loading()" (click)="load(page() + 1)">
            Next
          </button>
        </div>
      </div>
    }
  </div>
</section>
